import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const registerUser   = (data)    => api.post('/auth/register', data);
export const loginUser      = (data)    => api.post('/auth/login', data);
export const getMe          = ()        => api.get('/auth/me');
export const updateProfile  = (data)    => api.put('/auth/profile', data);
export const getTutors      = (params)  => api.get('/tutors', { params });
export const getTutorById   = (id)      => api.get(`/tutors/${id}`);
export const getStudents    = (params)  => api.get('/students', { params });
export const getStudentById = (id)      => api.get(`/students/${id}`);
export const createOrder    = (targetUserId) => api.post('/payment/create-order', { targetUserId });
export const verifyPayment  = (data)    => api.post('/payment/verify', data);
export const getMyPayments  = ()        => api.get('/payment/my-history');
export const getAdminStats  = ()        => api.get('/admin/stats');
export const getPendingUsers= ()        => api.get('/admin/pending');
export const approveUser    = (id)      => api.put(`/admin/approve/${id}`);
export const rejectUser     = (id)      => api.put(`/admin/reject/${id}`);
export const getAllUsers     = (params) => api.get('/admin/users', { params });
export const getAllPayments  = ()       => api.get('/admin/payments');

export default api;
